import { Building } from '@/reducers/types'

import { buildFlagsPayload, toFlags } from '../../../features/places-features.rules'
import { buildPlaceUpdatePayload } from '../../../place-payload'
import { LanguagesFormData, normalizeLanguages } from './languages-tab.constants'

// Note: called with values that passed makeLanguagesSchema. All three fields are always sent - it also repairs an `availableLocale` stored as a string.
// The rest is what every Places save needs (code, tags, the guarded flags - see place-payload.ts
// and ALWAYS_SENT_FLAGS); nothing else changes.
export const getLanguagesPayload = ({
  server,
  values,
}: {
  server: Building
  values: LanguagesFormData
}): Record<string, unknown> => {
  const flags = buildFlagsPayload({
    isAdmin: true,
    next: toFlags(server),
    server,
  })

  return buildPlaceUpdatePayload({
    flags,
    scalars: {
      // Note: only puts them in the fixed order - English and the default are already validated
      availableLocale: normalizeLanguages(values.availableLocale),
      i18nAvailable: values.i18nAvailable,
      locale: values.locale,
    },
    server,
  })
}
